import React from 'react';

const AdminPage: React.FC = () => (
  <div className="p-6">
    <h1 className="text-2xl font-bold text-gray-900 mb-4">Administração</h1>
    <p className="text-gray-600">Acesse Usuários ou Empresas pelo menu lateral.</p>
  </div>
);

export default AdminPage;